export default {
	init() {
		$(function () {
			$('[data-youtube]').click(function () { 
				var id = $(this).attr('data-youtube'); 
				var src = '//www.youtube.com/embed/'+id+'?html5=1&autoplay=1&rel=0';
				var iframe = '<iframe id="youtube" width="100%;" height="258px" class="yt_players" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:258px;width:100%;top:0px;left:0px;right:0px;bottom:0px;z-index:999" src="'+src+'" allowfullscreen></iframe>';
				$(this).find(".video-wrapper").html(iframe);
				return false;
			});
			$('.quotes').slick({
				variableWidth: false,
				adaptiveHeight: true,
				fade: false,
				dots: true,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
			});
			$('.vacatureContainer').slick({
				dots: false,
				arrows: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 400,
				prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
				nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					},
				}, {
					breakpoint: 580,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
					},
				}],
			});
			$('.postContainer').slick({
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 400,
				prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
				nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
			});
			$('a.readMore').click(function () {
				jQuery(this).siblings('.excerpt').slideToggle(200);
				jQuery(this).siblings('.whole-post').slideToggle(200);
				jQuery('a.readMore').css({'display':'none'});
				return false;
			});
			$('.accordion-toggle').on('click', function(event){
				event.preventDefault();
				var accordion = $(this);
				var accordionContent = accordion.next('.menu-informatie-container');
				accordion.toggleClass("open");
				accordionContent.slideToggle(0);
			});
			$('.slider-for').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: true,
				fade: false,
				autoplay: false,
			});
			$('.slider-for-blog').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				fade: false,
				autoplay: false,
			});
			$('.animated-icon').click(function () {
				$(this).toggleClass('open');
			});
			$('.navbar-toggler').on('click', function () {
				$('.animated-icon').toggleClass('open',0);
			});
			$('#query').keyup(function () {
				if ($(this).val() == '') {
					$('#submit').prop('disabled', true);
				} else {
					$('#submit').prop('disabled', false);
				}
			}).keyup();
			$('#queryMobile').keyup(function () {
				if ($(this).val() == '') {
					$('#submitMobile').prop('disabled', true);
				} else {
					$('#submitMobile').prop('disabled', false);
				}
			}).keyup();
			$.fn.is_on_screen = function(){
				var win = $(window);
				var viewport = {
					top : win.scrollTop(),
					left : win.scrollLeft(),
				};
				viewport.right = viewport.left + win.width();
				viewport.bottom = viewport.top + win.height();
				var bounds = this.offset();
				bounds.right = bounds.left + this.outerWidth();
				bounds.bottom = bounds.top + this.outerHeight();
				return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
			};
			if( $('.headerSite').length > 0 ) {
				if( $('.headerSite').is_on_screen() ) {
					$("#secNav").slideUp(300);
					$(".logoTopStick").fadeIn(300);
				} else {
					$("#secNav").slideDown(300);
					$(".logoTopStick").attr("style", "display: none !important");
				}
			}
			$(window).scroll(function() {
				if( $('.headerSite').length > 0 ) {
					if( $('.headerSite').is_on_screen() ) {
						$("#secNav").slideUp(300);
						$(".logoTopStick").fadeIn(300);
					} else {
						$("#secNav").slideDown(300);
						$(".logoTopStick").attr("style", "display: none !important");
					}
				}
				if ($(window).scrollTop() > 400) {
					$('.back-top').fadeIn();
				} else {
					$('.back-top').fadeOut();
				}
			});
			$("a.mapLink").on("click", function(e){
				e.preventDefault();
				$(this).addClass("activeMap"); 
				$(this).siblings().removeClass("activeMap");
			});
			$('a.showmenuFilter').click(function(e) {
                e.preventDefault();
                $('.filter').slideToggle(0);
			});
			$('a.showMap').click(function(e) {
                e.preventDefault();
                $('.filterMap').slideToggle(0);
                $('.grid').slideToggle(0);
                $(this).addClass("activeMap");
                $('a.showGrid').removeClass("activeGrid");
                $('a.showMap').hide();
                $('a.showGrid').show();
			});
			$('a.showGrid').click(function(e) {
                e.preventDefault();
                $('.grid').slideToggle(0);
                $('.filterMap').slideToggle(0);
                $(this).addClass("activeGrid");
                $('a.showMap').removeClass("activeMap");
                $('a.showMap').show();
                $('a.showGrid').hide();
			});
			$("#solliciterenBtn").click(function() {
				$('html, body').animate({
					scrollTop: $("#solliciteren").offset().top,
				}, 800);
			});
			$('.back-top').click(function () {
				$('body,html').animate({
					scrollTop: 0,
				}, 800);
				return false;
			});
			$('#accordion .collapseBtn').on('click', function() {
				$(this).find('.indicator').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');
			});
		});
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js